module.exports = __webpack_public_path__ + "static/media/logo_kan2.4d8a1651.svg";